import { CHALLENGE_ACTIVITY_TYPE_ID, DURATION_TYPE } from '../ChallengePage/constants';
export { DURATION_TYPE } from '../ChallengePage/constants';

export const CREATE_STEP = {
    TYPE: 1,
    PARTICIPANT: 2,
    DURATION: 3,
    SUMMARY: 4
};

export const PARTICIPANT_TYPE = {
    CONNECTIONS: 1,
    GROUP: 2
};

export const availableTypes = [
    CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_STEPS_COUNT,
    CHALLENGE_ACTIVITY_TYPE_ID.RUNNING,
    CHALLENGE_ACTIVITY_TYPE_ID.CYCLING,
    CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING
];

export const wheelchairAvailableTypes = [
    CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_PUSHES_COUNT,
    CHALLENGE_ACTIVITY_TYPE_ID.PUSHING_DISTANCE,
    CHALLENGE_ACTIVITY_TYPE_ID.CYCLING,
    CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING
];

export const wheelchairOnly = [
    CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_PUSHES_COUNT,
    CHALLENGE_ACTIVITY_TYPE_ID.PUSHING_DISTANCE
];

export const nonWheelchairOnly = [CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_STEPS_COUNT, CHALLENGE_ACTIVITY_TYPE_ID.RUNNING];

export const supportAllTypes = [CHALLENGE_ACTIVITY_TYPE_ID.CYCLING, CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING];

export const groupChallengeTypes = [
    CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_STEPS_COUNT,
    CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_PUSHES_COUNT,
    CHALLENGE_ACTIVITY_TYPE_ID.PUSHING_DISTANCE,
    CHALLENGE_ACTIVITY_TYPE_ID.RUNNING,
    CHALLENGE_ACTIVITY_TYPE_ID.CYCLING,
    CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING,
    CHALLENGE_ACTIVITY_TYPE_ID.WALKING
];

export const activityIconClassName = (challengeType, wheelchairMode) => {
    switch (challengeType) {
        case CHALLENGE_ACTIVITY_TYPE_ID.WALKING:
            return 'icon-activity-walking';
        case CHALLENGE_ACTIVITY_TYPE_ID.RUNNING:
            return 'icon-activity-running';
        case CHALLENGE_ACTIVITY_TYPE_ID.CYCLING:
            return wheelchairMode ? 'icon-activity-hand-cycling' : 'icon-activity-cycling';
        case CHALLENGE_ACTIVITY_TYPE_ID.SWIMMING:
            return 'icon-activity-swimming';
        case CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_STEPS_COUNT:
            return 'icon-steps-1';
        case CHALLENGE_ACTIVITY_TYPE_ID.WELLNESS_PUSHES_COUNT:
            return 'icon-activity-wheelchair-push-walk';
        case CHALLENGE_ACTIVITY_TYPE_ID.PUSHING_DISTANCE:
            return 'icon-activity-wheelchair-push-run';
        default:
            return '';
    }
};

export const durationTypes = [DURATION_TYPE.ONE_DAY, DURATION_TYPE.WEEKEND, DURATION_TYPE.WEEK, DURATION_TYPE.MONTH];
